// ============================================================================
// HEBREW TRANSLATIONS - CHAPTER 8: עזרת עליון (בונוס)
// ============================================================================
// שלב 92 (שלב בונוס אחד, 3 שאלות)

export const chapter8Translations = {
  name: "עזרת עליון",
  description: "יושב בסתר עליון בצל שדי יתלונן",
  
  spiritualWisdom: {
    principle: "הגעת לפסגת ההר, והידע נרכש",
    scripture: "יושב בסתר עליון בצל שדי יתלונן (תהילים 91:1)",
    application: "אמונה בלתי מעורערת דורשת ניסיון חיים, רחמים ואהבת אמת של ישוע. הניסיונות יבדקו את לבך, את הדרך האמיתית שנבחרה."
  },
  
  levels: {
    92: {
      name: "סתר עליון",
      challenge: "אתה בפסגת ההר... אבל האמונה הבלתי מעורערת מתחילה עכשיו...",
      easy: {
        question: "מי ישוע בשבילך באופן אישי?",
        options: [
          "נביא פשוט",
          "האדון והמושיע האישי שלי",
          "אגדה",
          "פילוסוף"
        ],
        hint: "הוא זה שנותן את חייו כדי להציל אותנו",
        funFact: "✝️ ישוע הוא אלוהים! הוא לא רק דמות היסטורית - הוא חי ורוצה קשר אישי עם כל אחד מאיתנו!"
      },
      medium: {
        question: "מדוע צום כמו דניאל מאפשר לנו לשמוע את אלוהים טוב יותר?",
        options: [
          "כדי לרדת במשקל",
          "כדי לשלול מעצמנו את מה שאנחנו אוהבים ולקבל לב שהשתנה",
          "כדי להרשים אחרים",
          "כדי להיות חזק יותר"
        ],
        hint: "שלול מעצמך את מה שאתה הכי אוהב, בשקט ובחוכמה",
        funFact: "🙏 צום רוחני מכין את לבנו לשינויים עמוקים - לעתים קרובות כואבים - שמקרבים אותנו לאלוהים!"
      },
      hard: {
        question: "מהי התגובה האמיתית של הלב מול כל הידע הנרכש הזה?",
        options: [
          "אני עכשיו מושלם",
          "אני נותן לך את לבי ישוע ורוצה להיטבל",
          "אני יודע יותר טוב מאחרים",
          "אני כבר לא צריך עזרה"
        ],
        hint: "אמונה אמיתית מובילה להתמסרות מוחלטת ולמחויבות לישוע",
        funFact: "🌟✨ הגעת לפסגת ההר, והידע נרכש ✨\n\n💖 אמונה בלתי מעורערת דורשת ניסיון חיים, רחמים ואהבת אמת של ישוע 💖\n\n🔥 הניסיונות השונים של החיים יבדקו את דרכך, את השביל האמיתי שאנחנו בוחרים, את לבנו 🔥\n\n😔 אנחנו נשארים לא מושלמים, הרצונות שלנו רבים, ואהבת הרווח או הנוחות האישית שלנו הופכת לעתים קרובות מדי לעדיפות האגואיסטית שלנו 😔\n\n🙏 בקש מאלוהים חוכמה, את אהבתו, את כוחו, והכר בענווה בחולשותיך, כי אנחנו לא יכולים להסתיר ממנו שום דבר... שום דבר 🙏\n\n🥖 צום כמו דניאל: שלול מעצמך לרגע את מה שאתה הכי אוהב, בשקט ובחוכמה 🥖\n\n💫 זה יאפשר לך לשמוע את אלוהים טוב יותר, לקבל נטייה של לב מוכנה לשינויים עמוקים 💫\n\n🌙 אז, החלומות והחזיונות יהפכו ברורים יותר, כמו ליוסף 🌙\n\n⚠️ היזהר מגאווה: אל תיכנע ל'אני תמיד צודק' או 'אני יודע יותר טוב' ⚠️\n\n🎁 כי התגלות אלוהים היא חסד יוצא דופן 🎁\n\n💝 לקבל אמונה זה להיכנס לקשר ולמסע חופשי של הלב 💝\n\n🦸‍♂️ זה יהפוך אותך לגיבורים חזקים, מסוגלים לבלתי אפשרי 🦸‍♂️\n\n✝️ בפסגת הידע, הלב הכן אומר: 'אני נותן לך את לבי ישוע ורוצה להיטבל' ✝️\n\n🏔️ הגעת לפסגת ההר, תאחז חזק, התמיד! 🏔️\n\n⬇️ צריך לרדת ולשאת את האוצר היקר הזה: תקוות החיים הנצחיים ⬇️\n\n🏆✨ כל הכבוד! אנחנו גאים בך ✨🏆\n🌟 אומץ נושא שלום אמיץ 🌟\n🕊️✨ שאלוהים יברך אותך ✨🕊️"
      }
    }
  }
};

export default chapter8Translations;
